import { render, staticRenderFns } from "./ChangeSound.vue?vue&type=template&id=649da9d0&scoped=true&"
import script from "./ChangeSound.vue?vue&type=script&lang=js&"
export * from "./ChangeSound.vue?vue&type=script&lang=js&"
import style0 from "./ChangeSound.vue?vue&type=style&index=0&id=649da9d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649da9d0",
  null
  
)

export default component.exports